import { ServiceException as __ServiceException, } from "@smithy/smithy-client";
export { __ServiceException };
export class LocationServiceException extends __ServiceException {
    constructor(options) {
        super(options);
        Object.setPrototypeOf(this, LocationServiceException.prototype);
    }
}
